import React, { Component } from "react";
import ReactDom from "react-dom";
import classNames from "classnames";
import _ from "lodash";
import $ from "jquery";

import {
    withValidationInputDefaultProps,
    withValidationInputPropTypes,
    sharedFormInputPropTypes
} from "./prop-types";
import { FormContext } from "../../forms/form/FormContext";
import { DefaultValidity } from "./DefaultValidity";

export function valueExists(value) {
    return !(
        _.isNil(value) ||
    value === "" ||
    (Array.isArray(value) && !value.length)
    );
}

export function withValidation(WrappedComponent, params = {}) {
    class WithValidation extends Component {
        constructor(props) {
            super(props);

            // Flag for whether or not blur event has been triggered, to be used in the onChange handler
            this.hasBlurFired = false;

            const { value } = this.props;

            if (!this.props.validation)
                throw new Error("You must provide a validation prop");
            this.state = {
                error: this.props.validation.error || false,
                value,
                formSubmitted: false,
                inputAttr: "",
                validateOn: _.get(this.props, "validation.validateOn", ""),
                isPristine: true
            };

            if(this.props.validation.checkValidPhone) {
            }
                
            this.handleChange = this.handleChange.bind(this);
            this.handleBlur = this.handleBlur.bind(this);
            this.handleValidation = this.handleValidation.bind(this);
            this.getErrorMessage = this.getErrorMessage.bind(this);
            this.wrappedComponentHandleChange = null;
            this.controllingValues = {};
        }

        isDependentFieldChange(event, context) {
            if (context.controlling) {
                return this.props.name in context.controlling && context.controlling[this.props.name].indexOf(event.target.name) > -1;
            }
            return false;
        }
        
        getControllingValues(context) {
            let controllingValues = {};
            if (context.controlling[this.props.name]) {
                controllingValues = _.transform(context.elements, (result, value, key) => {
                    if (context.controlling[this.props.name].indexOf(key) > -1) {
                        result[key] = value.value;
                    }
                });
            }
            return controllingValues;
        }
        
        getErrorMessage() {
            const { validateOn } = this.state;
            
            // Displaying error message only if input will be validated on submit or form has already been submitted
            if (validateOn !== "submit" || _.indexOf(validateOn, "submit") === -1) {
                if (this.state.error) {
                    if (
                        typeof this.state.inputAttr === "object" &&
                        Object.keys(this.state.inputAttr)[0] === "pattern"
                    ) {
                        const pattern = _.get(
                            this.props,
                            "validation.message.pattern",
                            false
                        );
                        return pattern && pattern[this.state.inputAttr.pattern];
                    }
                            
                    switch (this.state.inputAttr) {
                    case "required":
                        return _.get(
                            this.props,
                            "validation.message.required",
                            DefaultValidity.requiredMessage
                        );
                    case "minlength":
                        return _.get(
                            this.props,
                            "validation.message.minlength",
                            `${DefaultValidity.minlengthMessage} ${this.props.validation.minlength} characters.`
                        );
                    case "maxlength":
                        return _.get(
                            this.props,
                            "validation.message.maxlength",
                            `${DefaultValidity.maxlengthMessage} ${this.props.validation.maxlength} characters.`
                        );
                    case "requirelower":
                        return _.get(
                            this.props,
                            "validation.message.requirelower",
                            DefaultValidity.requirelowerMessage
                        );
                    case "requireupper":
                        return _.get(
                            this.props,
                            "validation.message.requireupper",
                            DefaultValidity.requireupperMessage
                        );
                    case "requirenumber":
                        return _.get(
                            this.props,
                            "validation.message.requirenumber",
                            DefaultValidity.requirenumberMessage
                        );
                    case "min":
                        return _.get(
                            this.props,
                            "validation.message.min",
                            DefaultValidity.minMessage
                        );
                    case "max":
                        return _.get(
                            this.props,
                            "validation.message.max",
                            DefaultValidity.maxMessage
                        );
                    case "pattern":
                        return _.get(this.props, "validation.message.pattern", false);
                    case "mustNotBePoBox":
                        return _.get(
                            this.props,
                            "validation.message.mustNotBePoBox",
                            DefaultValidity.poboxMessage
                        );  
                    case "tollFreeCheck":
                        return _.get(
                            this.props,
                            "validation.message.tollFreeNumberMessage",
                            DefaultValidity.tollFreeNumberMessage
                        );
                    case "validPhoneCheck":
                        return _.get(
                            this.props,
                            "validation.message.invalidPhoneMessage",
                            DefaultValidity.invalidPhoneMessage
                        );
                                                                                                                            
                    default:
                        return (
                            _.get(this.props, "validation.message.default", false) || ""
                        );
                    }
                }
            }
        }
                                                                                                                    
        handleChange(event, context) {
            let { checked, value } = event.target;
            const {elements, handleChange, controlling} = context;
                                                                                                                        
            let isInputError = false;
                                                                                                                        
            if (this.isDependentFieldChange(event, context)) {
                this.controllingValues = this.getControllingValues(context);
                if (valueExists(this.state.value) && this.props.validation.checkValidity) {
                    isInputError = this.handleDependentValidation(event, context);
                }
            }
            else {
                if (params.type === "checkbox" && !checked) {
                    value = "";
                }
        
                const { validateOn } = this.state;

                this.wrappedComponentHandleChange = handleChange;
                this.setState({ value, isPristine: false });

                if (
                    Array.isArray(validateOn) &&
          _.indexOf(validateOn, "keyup") !== -1 &&
          _.indexOf(validateOn, "blur") !== -1
                ) {
                    // validation onChange will only happen if 'blur' has been included in the validateOn prop to check on
                    // and the event fired, or if the form has been submitted
                    if (
                        this.shouldValidateOnKeyup(validateOn) &&
            (this.hasBlurFired || this.state.formSubmitted)
                    ) {
                        isInputError = this.handleValidation(value, event);
                    }
                } else if (this.shouldValidateOnKeyup(validateOn)) {
                    isInputError = this.handleValidation(value, event);
                }
            }

            // form handle change
            handleChange && handleChange(event, !isInputError);

            const dependentFields = _.get(elements, `${this.props.name}.dependentFields`, false);
            if (dependentFields) {
                _.forEach(dependentFields, (field) => {
                    elements[field].handleChange(event, context);
                })
            }

            return !isInputError; // valid
        }

        handleValidation(value, event) {
            let validationResult;
            if (
                this.props.validation.validationRegex &&
                this.props.validation.checkValidity
            ) {
                throw new Error(
                    "Not allowed - can only provide one prop, either validationRegex or checkValidity()"
                );
            }

            const checkValidityFnProvided = _.get(
                this.props,
                "validation.checkValidity",
                false
            );
            const regexProvided = _.get(
                this.props,
                "validation.validationRegex",
                false
            );

            const useDefaults = !checkValidityFnProvided && !regexProvided;

            
            if (_.get(this.props, "validation.required", false)) {
                if (!valueExists(value)) {
                    this.setState({
                        inputAttr: "required",
                        error: true
                    });

                    return true;
                } // else continue
            } else {
                // not required
                if (!valueExists(value)) {
                    this.setState({
                        error: false
                    });

                    return false;
                } // else continue
            }

            if (useDefaults) {
                const defaultValidity = new DefaultValidity(this.props.validation);
                validationResult = defaultValidity.checkValidity(
                    value,
                    this.controllingValues,
                    event
                );
                validationResult =
          typeof validationResult === "object"
              ? validationResult
              : { isValid: validationResult };
                this.setState({
                    inputAttr: validationResult.inputAttr,
                    error: !validationResult.isValid
                });
                return !validationResult.isValid;
            } else if (checkValidityFnProvided) {
                validationResult = this.props.validation.checkValidity(
                    value,
                    this.controllingValues,
                    event
                );
                validationResult =
          typeof validationResult === "object"
              ? validationResult
              : { isValid: validationResult };
                this.setState({
                    inputAttr: validationResult.inputAttr,
                    error: !validationResult.isValid
                });

                return !validationResult.isValid;
            }
            const { validationRegex } = this.props.validation;
            validationResult = {
                isValid:
          validationRegex && validationRegex.test
              ? validationRegex.test(value)
              : true
            };
            this.setState({
                inputAttr: "",
                error: !validationResult.isValid
            });
            return !validationResult.isValid;
        }

        handleDependentValidation(event, context) {
            let validationResult = this.props.validation.checkValidity(
                context.elements[this.props.name].value,
                this.controllingValues,
                event
            );
            validationResult =
          typeof validationResult === "object"
              ? validationResult
              : { isValid: validationResult };
            this.setState({
                inputAttr: validationResult.inputAttr,
                error: !validationResult.isValid
            });

            return !validationResult.isValid;
        }

        shouldValidateOnKeyup(validateOn) {
            return (
                this.state.error ||
        validateOn === "keyup" ||
        (_.indexOf(validateOn, "keyup") !== -1 &&
          (validateOn !== "submit" || _.indexOf(validateOn, "submit") === -1))
            );
        }

        shouldValidateOnBlur(validateOn) {
            if (
                this.isPristineLike() &&
        !_.get(this.props, "validation.required", false)
            )
                return false;
            return (
                validateOn === "blur" ||
        (_.indexOf(validateOn, "blur") !== -1 &&
          (validateOn !== "submit" || _.indexOf(validateOn, "submit") === -1))
            );
        }

        isPristineLike() {
            return this.state.isPristine || !valueExists(this.state.value);
        }

        handleBlur(event, handleChange) {
            const { value } = event.target;
            let isInputError = false;
            const { validateOn } = this.state;

            this.hasBlurFired = event.type === "blur";

            if (this.shouldValidateOnBlur(validateOn)) {
                isInputError = this.handleValidation(value, event);
                // form handle change
                handleChange && handleChange(event, !isInputError);
            }
        }

        handleSubmit(formEle, refEle) {
            const { validation } = this.props;
            const eventObj = {
                target: {
                    name: refEle.name,
                    value: refEle.value
                }
            };

            formEle.off("submit.validation");
            formEle.on("submit.validation", evt => {
                const { validateOn } = this.state;
                let isInputValid = true;

                // On initial form submit, removing submit as the only event to validate on
                if (validateOn === "submit") {
                    this.setState({ validateOn: "" });
                } else if (_.indexOf(validateOn, "submit") !== -1) {
                    validateOn.splice(_.indexOf(validateOn, "submit"), 1);
                    this.setState({ validateOn });
                }

                if (_.get(validation, "checkValidity")) {
                    const validationResult = validation.checkValidity(
                        eventObj.target.value,
                        this.state.controllingValues,
                        evt
                    );
                    isInputValid =
            typeof validationResult === "object" && validationResult.isValid;
                    this.setState({
                        formSubmitted: true
                    });
                } else if (validation.validationRegex) {
                    isInputValid = validation.validationRegex.test(eventObj.target.value);
                    this.setState({
                        formSubmitted: true
                    });
                }

                // If there happens to be a change in the input error state after submission and an onChange handler was
                // passed in as a prop, call the handler from props
                if (this.props.handleChange) {
                    this.wrappedComponentHandleChange(eventObj, isInputValid);
                }

                if (!isInputValid) {
                    setTimeout(() => {
                        $(refEle).focus();
                    }, 0);
                }
            });
        }

        validateOnRegisterUpdate(input) {
            const value = this.props.value || _.get(input, "value", null);
            let controllingValues = {};
            if (this.props.context.controlling[this.props.name]) {
                controllingValues = _.transform(this.props.context.elements, (result, value, key) => {
                    if (this.props.context.controlling[this.props.name].indexOf(key) > -1) {
                        result[key] = value.value;
                    }
                });
            }

            if (_.get(this.props, "validation.required", false)) {
                if (!valueExists(value)) {
                    return false;
                } // else continue
            } else {
                // not required
                if (valueExists(value)) {
                    return true;
                } // else continue
            }

            if (value != null || this.props.value === "") {
                const eventMock = {
                    target: {
                        name: this.props.name || input.name,
                        value: this.props.value
                    }
                };

                if (this.props.validation.checkValidity) {
                    const validationResult = this.props.validation.checkValidity(
                        eventMock.target.value,
                        controllingValues,
                        eventMock
                    );
                    return typeof validationResult === "object"
                        ? validationResult.isValid
                        : validationResult;
                }
                return (
                    this.props.validation.validationRegex &&
          this.props.validation.validationRegex.test(eventMock.target.value)
                );
            }
        }

        value(context) {
            const { name, uncontrolled, value } = this.props;
            if (context.controlling && name in context.controlling && _.isEmpty(this.controllingValues)) {
                this.controllingValues = this.getControllingValues(context);
            }
            const contextValue = _.get(context, `elements[${name}].value`);
            const resolvedValue = contextValue !== undefined && contextValue !== null ? contextValue : value;
            const valueAttr = {};

            // set input to be uncontrolled (value is determined by DOM input) or controlled (value is determined by prop
            // received by component)
            if (uncontrolled && resolvedValue) {
                valueAttr.defaultValue = resolvedValue;
            } else if (!uncontrolled) {
                valueAttr.value = resolvedValue;
            }

            return valueAttr;
        }

        render() {
            this.className = classNames(this.props.classNames);

            this.classNameWrapper = classNames({
                "has-error": this.state.error,
                "input-group": !!this.props.addon
            });

            return (
                <FormContext.Consumer>
                    {context => (
                        <WrappedComponent
                            className={this.className}
                            context={context}
                            error={this.state.error}
                            errorMessage={this.getErrorMessage()}
                            handleBlur={this.handleBlur}
                            handleChange={this.handleChange}
                            handleValidation={this.handleValidation}
                            ref={refEle => {
                                // Validating text input on submission of parent xt-form element
                                // TODO: Change to select closest form when xt-forms are removed from project
                                refEle =
                  ReactDom.findDOMNode(refEle) &&
                  ReactDom.findDOMNode(refEle).querySelector("input");

                                const formEle = $(refEle).closest("[xt-form]");

                                if (formEle.length && refEle) {
                                    this.handleSubmit(formEle, refEle);
                                }
                            }}
                            wrapperCssClasses={this.classNameWrapper}
                            validateOnRegisterUpdate={this.validateOnRegisterUpdate}
                            {...this.props}
                            {...this.value(context)}
                        />
                    )}
                </FormContext.Consumer>
            );
        }
    }

    WithValidation.defaultProps = {
        ...withValidationInputDefaultProps
    };

    WithValidation.propTypes = {
        ...withValidationInputPropTypes,
        ...sharedFormInputPropTypes
    };

    return WithValidation;
}
